import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import { contactList, contactAdd, contactDelete, contactUpdate, contactUpdateSeq } from '../../helpers/api';
import {
    contactListSuccess,
    contactListError,
    contactAddSuccess,
    contactAddError,
    contactDeleteSuccess,
    contactDeleteError,
    contactUpdateSuccess,
    contactUpdateError,
    contactUpdateSeqSuccess,
    contactUpdateSeqError,
} from './actions';
import { ContactUsActionTypes } from './constants';
import { SagaIterator } from '@redux-saga/core';
import { AxiosResponse } from 'axios';

function* contactListSaga(): SagaIterator {
    try {
        const response = yield call(contactList);
        if (response?.data) {
            const contactList = response?.data?.data;
            yield put(contactListSuccess(contactList));
        } else {
            yield put(contactListError('No List Found'));
        }
    } catch (error: any) {
        yield put(contactListError(error.message || 'Error Occurred'));
    }
}

function* contactAddSaga(action: any): SagaIterator {
    try {
        const response = yield call(contactAdd, action.payload);
        yield put(contactAddSuccess(response?.data?.message));
    } catch (error: any) {
        yield put(contactAddError(error.message || 'Error Occurred'));
    }
}

function* contactDeleteSaga(action: any): SagaIterator {
    try {
        const response = yield call(contactDelete, action.payload);
        yield put(contactDeleteSuccess(response?.data?.message));
    } catch (error: any) {
        yield put(contactDeleteError(error.message || 'Error Occurred'));
    }
}

function* contactUpdateSaga(action: any): SagaIterator {
    try {
        const response = yield call(contactUpdate, action.payload);
        yield put(contactUpdateSuccess(response?.data?.message));
    } catch (error: any) {
        yield put(contactUpdateError(error.message || 'Error Occurred'));
    }
}

function* contactUpdateSeqSaga(action: any): SagaIterator {
    try {
        const response = yield call(contactUpdateSeq, action.payload?.data);
        yield put(contactUpdateSeqSuccess(response?.data?.message));
    } catch (error: any) {
        yield put(contactUpdateSeqError(error.message || 'Error Occurred'));
    }
}

function* watchContactList() {
    yield takeEvery(ContactUsActionTypes.CONTACT_LIST, contactListSaga);
}
function* watchContactAdd() {
    yield takeEvery(ContactUsActionTypes.CONTACT_ADD, contactAddSaga);
}
function* watchContactDelete() {
    yield takeEvery(ContactUsActionTypes.CONTACT_DELETE, contactDeleteSaga);
}
function* watchContactUpdate() {
    yield takeEvery(ContactUsActionTypes.CONTACT_UPDATE, contactUpdateSaga);
}
function* watchContactUpdateSeq() {
    yield takeEvery(ContactUsActionTypes.CONTACT_UPDATE_SEQ, contactUpdateSeqSaga);
}

function* contactSaga() {
    yield all([
        fork(watchContactList),
        fork(watchContactAdd),
        fork(watchContactDelete),
        fork(watchContactUpdate),
        fork(watchContactUpdateSeq),
    ]);
}

export default contactSaga;
